import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../contexts/AppContext";
import { getUsers } from "../../services/clients";
import UsersTable from "../../components/Tables/UsersTable";

export const Users = () => {
  const { selectedClient } = useContext(AppContext);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        setUsers(await getUsers(selectedClient.public_id ?? selectedClient.id));
        console.log(users);
      } catch (error) {
        console.error(error);
      }
    };

    console.log("!!! SELECTED CLIENT FROM users: ", selectedClient);
    if (selectedClient) {
      fetchUsers();
    }
    // eslint-disable-next-line
  }, [selectedClient]);
  return (
    <div>
      <UsersTable
        users={users}
        onUpdated={(newUsers) => {
          setUsers(newUsers);
        }}
      />
    </div>
  );
};

export default Users;
